<template>
	<Page>
		<div class="intro-image asset-avatar-wrapper">
			<AssetAvatar v-if="asset" :asset="asset" />
		</div>

		<Section>
			<SectionLine>
				<div class="hint">Id</div>
				<div v-if="asset" class="break-all">{{ formatAddress(assetIdToString(asset.assetId)) }}</div>
			</SectionLine>

			<SectionLine>
				<div class="hint">Name</div>
				<div v-if="asset" class="break-all">{{ asset.name }}</div>
			</SectionLine>

			<SectionLine>
				<div class="hint">Description</div>
				<div v-if="asset" class="break-all">{{ asset.description }}</div>
			</SectionLine>

			<SectionLine>
				<div class="hint">Decimals</div>
				<div v-if="asset" class="break-all">{{ asset.decimals }}</div>
			</SectionLine>

			<SectionLine>
				<div class="hint">Reissuable</div>
				<div v-if="asset" class="break-all">{{ asset.reissuable }}</div>
			</SectionLine>
		</Section>

		<template #footer>
			<BaseButton @click="router.push({ path: '/transfer', query: { assetId: params.assetId } })"
				>Transfer</BaseButton
			>
		</template>
	</Page>
</template>

<script setup lang="ts">
import AssetAvatar from '@/components/AssetAvatar.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import Page from '@/components/ui/Page.vue';
import Section from '@/components/ui/Section.vue';
import SectionLine from '@/components/ui/SectionLine.vue';
import { useAsset } from '@/services/useAsset';
import { assetIdFromString, assetIdToString, formatAddress } from '@/utils';
import { useRouter, useRoute } from 'vue-router';
import * as yup from 'yup';

const router = useRouter();

const schema = yup.object().shape({
	assetId: yup.string().required('assetId field is required')
});

const params = schema.validateSync(useRoute().params);

const asset = await useAsset(assetIdFromString(params.assetId));
</script>

<style scoped>
.asset-avatar-wrapper {
	/* background-image: url('@/assets/images/slot.svg'); */
	background-size: cover;

	padding: 16px;
}
</style>
